
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goi-dich-vu-tiem-chung",
      function () {
        return require("private-next-pages/goi-dich-vu-tiem-chung/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goi-dich-vu-tiem-chung"])
      });
    }
  